import { addMinutes } from 'date-fns';

export default function parseMinutesToHourString(number) {
  const date = new Date(2024, 2, 27);
  const dateWithMinutes = addMinutes(date, number);

  return dateWithMinutes.toLocaleTimeString('pt-BR');
}